@let isMdOrAbove = viewportSelectors.isMdAndUp | select;
@let hasUnreadNotifications = notificationsSelectors.hasUnreadNotifications | select:false;
@let loaded = notificationsSelectors.loaded | select:false;

<div class="flex flex-col gap-y-4">
  <!-- Header Row -->
  <div class="flex flex-row items-center justify-between">
    <p [ngClass]="isDashboardView ? 'text-headline-small' : 'text-title-large'">{{ isDashboardView && isMdOrAbove ? 'Recent ' : '' }}Notifications</p>

    <!-- Clear All Button -->
    <mx-text-button mxHiddenUntilLoaded [reveal]="loaded" [label]="`Clear all (${notificationsSelectors.allUnreadNotificationsCount | select})`"
                    [enabled]="loaded && hasUnreadNotifications" (click)="clearAllNotifications()"/>
  </div>

  <div mxHiddenUntilLoaded [reveal]="loaded" class="flex flex-col gap-y-4">
    @if (hasUnreadNotifications) {
      <!-- List of Notifications -->
      <div class="flex flex-col">
        @for (notification of notificationsSelectors.latestUnreadNotifications | select; track notification.id) {
          <px-notification-list-item [notification]="notification" [showDivider]="!$last"/>
        }
      </div>

      <!-- Additional Notifications label -->
      @if (notificationsSelectors.hasAdditionalNotifications | select) {
        <p class="text-label-medium self-end">
          @let count = notificationsSelectors.additionalNotificationsCount | select:0;

          + {{ count }} additional notification{{ count > 1 ? 's' : '' }}
        </p>
      }
    } @else {
      <!-- Notifications list is empty -->
      <div class="w-full flex flex-row gap-x-4 pl-4 pr-3">
        <mat-icon class="w-6 shrink-0 mt-[2px] text-on-surface-variant material-icons-outlined">check_circle</mat-icon>
        <div class="flex flex-col">
          <p class="text-title-medium">You are all caught up!</p>
          <p class="text-body-medium text-on-surface-variant">You don’t have any new notifications.</p>
        </div>
      </div>
    }
  </div>
</div>
